
const rtl = (document.querySelector('html').getAttribute('dir') == 'rtl');

function initValidator() {
  // validator for phone numbers
  $.validator.addMethod('phoneNumber', function (value, element) {
    if(value.length > 0) {
      return $(element).intlTelInput("isValidNumber");
    } else {
      return true;
    }
  }, "Please enter a valid phone number");

  // validator for emirates ID
  $.validator.addMethod('emiratesId', function (value, element) {
      //console.log(element);
      return this.optional( element ) || /784-\d{4}-\d{7}-\d/.test( value );
  }, "Please enter a valid Emirate ID number");

  $.validator.addMethod("valueNotEquals", function(value, element, arg){
    return arg !== value;
  }, "Invalid choice.");

  $.validator.addMethod("selectRequired", function(value, element){
    if ($(element).parents('field-wrap').first().hasClass('hidden'))
      return true;
    return "default" !== value;
  }, "Please select");

  if (rtl) {
    $.validator.messages.selectRequired = "الرجاء اختيار";
    $.validator.messages.emiratesId = "يرجى إدخال رقم الهوية الإماراتية";
    $.validator.messages.phoneNumber = "صحيح  يرجى إدخال رقم هاتف";
  }
}

function formState($form, state) {
  switch (state) {
    case 'success':
      console.log('..form success..');
      if($form.data('collapse')){
        var $fields = $($form.find('.form-fields'));
        $('.preliminary').slideUp(300);
        $fields.slideUp(300);
      }
      $form.removeClass('state-working state-error');
      $form.addClass('state-success');
      if($form.data('reset')){
        setTimeout(function() {
          $form.removeClass('state-success');
          $form[0].reset();
        }, 2000);
      }
      break;
    case 'working':
      console.log('..form working..');
      $form.removeClass('state-error');
      $form.addClass('state-working');
      break;
    case 'error':
      console.log('..form error..');
      $form.removeClass('state-working');
      $form.addClass('state-error');
      setTimeout(function(){
        $form.removeClass('state-error');
      }, 2000);
      break;
  }
}

function formHandler(form) {
  $(form).find('[required]').each(function(){
    $(this).parents('.field-wrap').attr('field-required', true);
  });
  var telInput = $(form).find('[type="tel"]');
  if (telInput.length > 0) {
    telInput.intlTelInput({
      preferredCountries: ['ae','kw','sa','bh','om','qa'],
      excludeCountries: ['il'],
      utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.1.4/js/utils.js',
      separateDialCode: true,
      formatOnDisplay: true,
      autoPlaceholder: 'aggressive'
    })
  }
  if ($('input[name="emiratesId"]').length > 0) {
    var cleave = new Cleave('input[name="emiratesId"]', {
      prefix: '784',
      delimiter: '-',
      blocks: [3, 4, 7, 1]
    });
  }

  const datePickers = Array.from(document.querySelectorAll('input[type="date"]'));

  if(datePickers[0] && datePickers[0].type === 'text') {
    datePickers.forEach((input) => {
      new Pikaday({ field: input });
    })
  }

  $(form).find('select').on('change', function() {
      $(this).valid();
  })
  $(form).on({
    submit: function(event, data){
      event.preventDefault();
      event.stopPropagation();
      var form = this;
      var apiUrl = $(form).data('url');

      $(form).validate();
      if(!$(form).valid()) return;

      formState($(form), 'working');

      console.log(data);

      $(form).ajaxSubmit({
        type: 'POST',
        url: apiUrl,
        success: function(data) {
          formState($(form), 'success');
        },
        error: function(data){
          formState($(form), 'error');
        }
      });
    }
  }).validate({
    errorElement: 'span',
    errorPlacement: function errorPlacement(error, element) {
      const wrapper = element.parents('.field-wrap').first();
      if (wrapper.length > 0) {
        wrapper.append(error);
      } else {
        element.after(error);
      }
    },
    rules: {
      emiratesId: 'emiratesId',
      appointmentTime: 'selectRequired',
      mobile: 'phoneNumber'
    },
    messages: {
    }
  });
}
export default function () {
  const forms = Array.from(document.querySelectorAll('[data-form-handler]'));
  if(forms.length < 1) return;

  initValidator();
  forms.forEach((form) => {
    formHandler(form);
  })

}



// WEBPACK FOOTER //
// ./public/javascripts/modules/form-handler.js